import {Illustration} from 'shells/illustrations/illustration';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {Body} from 'shells/typography/body';

import type {ThreadStatus, ThreadType} from 'nutshell-graphql-types';

import {useGetChatSettings} from '../chat/graphql/hooks/use-get-chat-settings';
import {getEmptyStateValues} from '../helpers';

type Props = {
    status: ThreadStatus;
    canAccessSetup: boolean;
    threadType: ThreadType | null | undefined;
    selectedTab?: string | null;
};

export function ThreadContentEmptyState(props: Props) {
    const {chatSettings, isLoading} = useGetChatSettings();

    if (isLoading) {
        return <LoadingPage />;
    }

    const values = getEmptyStateValues(
        props.status,
        props.canAccessSetup,
        props.threadType,
        props.selectedTab,
        chatSettings
    );
    const imageSrc = values.image;
    const header = values.header;
    const text = values.text;

    return (
        <div
            // 400px plus padding
            style={{maxWidth: 528}}
            className='pad-64 flex flex-dir-col text-align-center justify-center border-box'
        >
            <div className='mb-32'>
                <Illustration src={imageSrc} width={200} />
            </div>
            <div className='text-align-center'>
                <div className='mb-16'>
                    <Body size='large' isBold={true}>
                        {header}
                    </Body>
                </div>
                <Body color='light'>{text}</Body>
            </div>
        </div>
    );
}
